import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSocket } from '../context/SocketContext';

const Navbar = () => {
  const { user, logout, isAdmin } = useAuth();
  const { connected } = useSocket();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (!user) {
    return (
      <nav className="bg-blue-600 text-white shadow-lg">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="text-xl font-bold">
              Die Stämme Def-Tool
            </Link>
            <div className="space-x-4">
              <Link to="/login" className="hover:text-blue-200">
                Anmelden
              </Link>
              <Link to="/register" className="hover:text-blue-200">
                Registrieren
              </Link>
            </div>
          </div>
        </div>
      </nav>
    );
  }

  return (
    <nav className="bg-blue-600 text-white shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="text-xl font-bold">
            Die Stämme Def-Tool
          </Link>
          
          <div className="flex items-center space-x-6">
            {/* Navigation Links */}
            <div className="hidden md:flex space-x-4">
              <Link to="/" className="hover:text-blue-200">
                Dashboard
              </Link>
              <Link to="/troops" className="hover:text-blue-200">
                Truppen
              </Link>
              <Link to="/sos" className="hover:text-blue-200">
                SOS
              </Link>
              <Link to="/tabs" className="hover:text-blue-200">
                Tabs
              </Link>
              {isAdmin() && (
                <Link to="/admin" className="hover:text-blue-200">
                  Admin
                </Link>
              )}
            </div>

            {/* Status Indicator */}
            <div className="flex items-center space-x-2">
              <div 
                className={`w-2 h-2 rounded-full ${
                  connected ? 'bg-green-400' : 'bg-red-400'
                }`}
                title={connected ? 'Verbunden' : 'Getrennt'}
              ></div>
              <span className="text-sm">
                {connected ? 'Online' : 'Offline'}
              </span>
            </div>

            {/* User Menu */}
            <div className="flex items-center space-x-4">
              <div className="text-sm">
                <div className="font-medium">{user.username}</div>
                <div className="text-blue-200 text-xs">
                  {user.world} • {user.role}
                </div>
              </div>
              <button
                onClick={handleLogout}
                className="bg-blue-700 hover:bg-blue-800 px-3 py-1 rounded text-sm"
              >
                Abmelden
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className="md:hidden border-t border-blue-500 py-2">
          <div className="flex flex-wrap gap-2">
            <Link to="/" className="px-3 py-1 rounded hover:bg-blue-700 text-sm">
              Dashboard
            </Link>
            <Link to="/troops" className="px-3 py-1 rounded hover:bg-blue-700 text-sm">
              Truppen
            </Link>
            <Link to="/sos" className="px-3 py-1 rounded hover:bg-blue-700 text-sm">
              SOS
            </Link>
            <Link to="/tabs" className="px-3 py-1 rounded hover:bg-blue-700 text-sm">
              Tabs
            </Link>
            {isAdmin() && (
              <Link to="/admin" className="px-3 py-1 rounded hover:bg-blue-700 text-sm">
                Admin
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
